import { render, staticRenderFns } from "./newTransferModal.vue?vue&type=template&id=cf73b24e"
import script from "./newTransferModal.vue?vue&type=script&lang=js"
export * from "./newTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports